import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChatBubble7: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconChatBubble7"><Path d="M12 2.5C17.4682 2.5 22 6.70021 22 12C22 17.2998 17.4682 21.5 12 21.5C10.369 21.5 8.82571 21.1273 7.46094 20.4658C6.36671 20.7491 5.24226 20.9252 4.06152 20.998L2.50879 21.0938L3.06641 19.6416C3.35697 18.885 3.59943 18.1423 3.76953 17.3955C2.65719 15.8665 2 14.0076 2 12C2 6.70021 6.53177 2.5 12 2.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChatBubble7;
